import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { environment } from "src/environments/environment";
import { EmailService } from "./email.service";
import Pusher from "pusher-js";
import { SharedDataService } from "../shared-data.service";
import { HotToastService } from "@ngneat/hot-toast";
import { EmailMessage, ThreadInfo } from "./email.types";
import { ActivatedRoute } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ImapConfigComponent } from "./imap-config/imap-config.component";
import { FilePreviewService } from "../main/common/file-preview.service";
import { JobsService } from "../main/accountant/jobs-and-tasks/jobs.service";
import { PinnedService } from "../main/accountant/pinned-panel/pinned.service";
import { MomentModule } from "ngx-moment";
import { EmailFormComponent } from "./email-form/email-form.component";
import { FormsModule } from "@angular/forms";
import { EmailContentComponent } from "./email-content/email-content.component";
import { PaginatorModule } from "primeng/paginator";
import { NgClass, NgIf } from "@angular/common";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { Editor, EditorModule } from "primeng/editor";
import { DatePickerModule } from "primeng/datepicker";

@Component({
  selector: "app-email",
  templateUrl: "./email.component.html",
  styleUrls: ["./email.component.scss"],
  imports: [
    BsDropdownModule,
    TooltipModule,
    NgClass,
    PaginatorModule,
    EmailContentComponent,
    FormsModule,
    NgIf,
    EmailFormComponent,
    MomentModule,
    EditorModule,
    DatePickerModule,
  ],
})
export class EmailComponent implements OnInit, OnDestroy {
  threads: EmailMessage[];
  mailbox: string = "PRIORITY";

  inboxes: any = [];

  connected = false;
  loading = true;
  refreshing = false;
  visible = false;
  selectedThread: EmailMessage = null;
  selectedMessage: EmailMessage = null;

  threadUUID: any = null;
  threadInfo: ThreadInfo = null;

  to: any = null;
  subject: any = null;
  message: any = null;

  modifiedMessage: any = null;

  composeMode = false;
  summary = false;
  cc = false;
  bcc = false;
  summarizeLoading = false;
  generateAiLoading = false;
  changeEmailToneLoading = false;
  generateMagicEmailLoading = false;

  newEmail: any = {
    to: [],
    cc: [],
    bcc: [],
    subject: "",
    body: "",
  };

  settings: any = {
    signature: "",
    greeting: "",
  };

  inboxAddress = null;

  collapsed = true;

  emailBody: any = null;
  pusher: Pusher;
  emailChannel: any;

  inboxState: string = null;

  imapPassword: string = null;

  public bsModalRef: BsModalRef;

  targetStartDate: any;
  dueDate: any;
  assignedTo: any = null;

  accountants: any = [];

  datepickerFormat = "mm-dd-yy";

  start = 0;
  rows = 20;
  totalRecords = 0;

  public inlineMode: object = { enable: true, onSelection: true };
  public toolbarSettings: Object = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "Formats",
      "-",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "CreateLink",
    ],
  };

  @ViewChild("messageInput", { static: false })
  messageInput: Editor;

  newEmailState: string = "closed";

  constructor(
    private emailService: EmailService,
    private sharedDataService: SharedDataService,
    private toastr: HotToastService,
    private route: ActivatedRoute,
    public modalService: BsModalService,
    private filePreviewService: FilePreviewService,
    public jobsService: JobsService,
    private pinnedService: PinnedService,
  ) {}

  ngOnInit() {
    this.pusher = new Pusher(environment.pusherConfig.pusherAppKey, {
      cluster: environment.pusherConfig.pusherAppCluster,
    });

    // this.emailService.getAuthStatus().subscribe((data: any) => {
    //   this.connected = data.connected;
    // });

    this.route.queryParams.subscribe((params) => {
      if (params["state"]) {
        this.inboxState = params["state"];
      }

      this.emailService.getInboxList().subscribe((res) => {
        this.inboxes = res;

        if (this.inboxes.length > 0) {
          this.emailService
            .getInboxSettings(this.inboxes[0].uuid)
            .subscribe((res) => {
              this.settings.signature = res["signature"];
              this.settings.greeting = res["greeting"];

              this.emailService.settings.signature = res["signature"];
              this.emailService.settings.greeting = res["greeting"];
            });

          this.emailService
            .getInboxState(
              this.sharedDataService.user.email,
              this.inboxes[0].uuid,
            )
            .subscribe(
              (res) => {
                this.inboxState = res["state"];
                this.inboxAddress =
                  res["address"] ?? this.sharedDataService.user.email;

                this.emailChannel = this.pusher.subscribe(
                  `email.${this.inboxAddress}`,
                );
                this.emailChannel.bind("new-email", (msg: any) => {
                  // this.toastr.success("New email received");

                  this.getEmails();
                });

                this.loading = false;

                this.getEmails();
              },
              (err) => {
                this.loading = false;
                this.inboxState = null;
              },
            );
        } else {
          this.loading = false;
          this.inboxState = null;
        }
      });
    });

    this.emailService.newEmailSent$.subscribe((sub) => {
      this.newEmailState = "closed";
      this.changeMailbox("SENT");
      this.getEmails();
    });

    this.emailService.resetEmailState$.subscribe((sub) => {
      this.selectedMessage = null;
      this.selectedThread = null;
      this.threadUUID = null;

      this.getEmails();
    });
  }

  ngOnDestroy() {
    if (this.emailChannel != null) {
      this.emailChannel.unbind();
    }

    this.pusher.unsubscribe(`email.${this.sharedDataService.user.email}`);
  }

  getAuthUrl(provider) {
    if (provider == "google") {
      this.bsModalRef = this.modalService.show(ImapConfigComponent);

      this.bsModalRef.content.onClose.subscribe((sub) => {
        if (sub == "new" || sub == "existing") {
          this.inboxState = "syncing";
        }
      });
      return;
    }

    this.emailService.getAuthUrl(provider, {}).subscribe((res: any) => {
      (window as Window).location = res.url;
    });
  }

  // {page: 2, first: 20, rows: 10, pageCount: 12}
  onPageChange(event) {
    this.start = event.first;
    this.rows = event.rows;

    this.getEmails();
  }

  getEmails() {
    this.loading = true;
    this.emailService
      .getEmails(this.inboxes[0].uuid, this.mailbox, this.start, this.rows)
      .subscribe((data: { threads: EmailMessage[]; total_records: number }) => {
        this.threads = data.threads;
        this.totalRecords = data.total_records;
        this.loading = false;
      });
  }

  refreshEmails() {
    this.refreshing = true;
    this.emailService
      .getEmails(this.inboxes[0].uuid, this.mailbox, this.start, this.rows)
      .subscribe((data: { threads: EmailMessage[]; total_records: number }) => {
        this.threads = data.threads;
        this.totalRecords = data.total_records;
        this.refreshing = false;
        this.toastr.success("Mailbox refreshed", {
          duration: 2000,
        });
      });
  }

  setSelectedMessage(message) {
    this.selectedMessage = message;
    this.emailBody = message;

    console.log("selected message", message);

    this.visible = true;
  }

  getEmailThread(thread) {
    this.threadUUID = thread.uuid;
    // this.setComposeMode(false); // call this function in email-content

    this.loading = true;
    this.emailService
      .getEmailThread(thread.uuid)
      .subscribe((data: EmailMessage[]) => {
        this.selectedThread = thread;

        this.selectedThread.messages = data;

        this.newEmail = {
          to: [],
          cc: [],
          bcc: [],
          subject: "",
          body: "",
        };

        if (
          this.selectedThread.messages[
            this.selectedThread.messages.length - 1
          ] != null
        ) {
          if (
            this.selectedThread.messages[
              this.selectedThread.messages.length - 1
            ]["cc"] != null
          ) {
            this.newEmail.cc = this.selectedThread.messages[
              this.selectedThread.messages.length - 1
            ]["cc"].map((address) => {
              return address.address;
            });
          }
        }

        this.newEmail.to.push(this.selectedThread.from_email.address);

        this.loading = false;

        if (this.mailbox == "PRIORITY") {
          this.emailService
            .getThreadInfo(thread.uuid)
            .then((data: ThreadInfo) => {
              this.threadInfo = data;

              this.jobsService
                .getAccountantsFromClientCompany(
                  this.threadInfo.client_company.id,
                )
                .then((res: any) => {
                  this.accountants = res.accountants;
                });
            });
        }

        // this.emailService.readEmailThread(thread.uuid).then((data: any) => {
        //
        //   thread.unread = false;
        // });
      });
  }

  changeMailbox(mailbox) {
    this.mailbox = mailbox;

    if (mailbox != "SETTINGS") {
      this.getEmails();
    }
  }

  openRemoveConnectionModal(modal) {
    this.bsModalRef = this.modalService.show(modal, {
      class: "modal-sm",
    });
  }

  removeEmailConnection() {
    this.emailService.removeEmailConnection(this.inboxes[0].uuid).subscribe(
      (res) => {
        this.inboxState = null;
        this.bsModalRef.hide();
        this.toastr.success("Email connection removed");
      },
      (err) => {
        this.toastr.error("Error removing email connection");
      },
    );
  }

  saveInboxSettings() {
    this.emailService
      .saveInboxSettings(this.inboxes[0].uuid, this.settings)
      .subscribe((res) => {
        this.toastr.success("Settings saved successfully");
      });
  }

  retryConnection() {
    this.emailService.retryConnection().then(
      (res) => {
        console.log(res);
        this.inboxState = null;
        this.inboxes = [];
      },
      (err) => {
        this.toastr.error(
          "Couldn't retry connection. Please reach out to support.",
        );
      },
    );
  }

  handleCancelCompose() {
    this.newEmailState = "closed";
    this.composeMode = false; // Ensure compose mode is reset
  }
}
